import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/AI.mp4';
import DatacenterImage2 from '../../../assets/images/itmonkeys-cyber-landing.jpeg';
import SecurityImg from '../../../assets/images/itmonkeys-cyber-img.jpeg';
import DatacenterImage from '../../../assets/images/data-center.jpeg';
import CloudImage from '../../../assets/images/cloud-image.png'
import { AnimatedGridPattern } from '../../ui/animated-grid-pattern';
import { cn } from "../../../lib/utils";
import { FeaturesSectionWithHoverEffects } from '../../ui/feature-section-with-hoover-effect';
import { cyberAuditFeatures } from '../../../data/features';
import CloudArchitectureImg from '../../../assets/images/logo-landing-itmonkeys-grey.png';

const IntroSectionLabAI: React.FC = () => {
  const { t } = useTranslation();
  const sectionIds = ['One', 'Two', 'Three'];
  return (
    <div>
    <div className="intro-section-migration">
    <div className="container-max-width tw-relative tw-flex tw-h-[500px] tw-w-full tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-border tw-bg-background tw-md:pt-20 tw-md:shadow-xl tw-mb-[3em]">
      <div className="centered-title-top">
      <div className="title-image-container">
        <img src={CloudArchitectureImg} alt={t('labAI.intro.imageAlt', 'Architecture IA')} className="title-below-image overflow-visible" />
      </div>
      <h2>{t('labAI.intro.title', 'Construisez des écosystèmes d\'agents IA')}</h2>
      <h3>{t('labAI.intro.subtitle', 'Le Lab AI d\'IT Monkeys est votre espace dédié à l\'innovation et à l\'expérimentation concrète avec les technologies d\'intelligence artificielle les plus avancées du marché.')}</h3>
      </div>
      <div className="tw-w-full tw-flex tw-flex-col tw-mt-8 tw-mt-[-8em]">
        <div className="tw-w-full tw-px-4 tw-mt-[3em]">
          <FeaturesSectionWithHoverEffects 
            limit={4} 
            displayInRow={true} 
            featuresData={cyberAuditFeatures}
          />
        </div>
      </div>
      <AnimatedGridPattern
        numSquares={30}
        maxOpacity={0.1}
        duration={3}
        repeatDelay={1}
        className={cn(
          "[mask-image:radial-gradient(500px_circle_at_center,white,transparent)]",
          "tw-inset-x-0 tw-inset-y-[-30%] tw-h-[200%] tw-skew-y-12",
        )}
      />
    </div>
    <div className="intro-section">
      <div className="intro-row-1">
        <div className="intro-text-1">
          <h2 className='blue-h2'>{t('labAI.section1.title', 'La collaboration intelligente')}</h2>
          <p className="subtitle">{t('labAI.section1.subtitle', 'L\'évolution de l\'IA en Entreprise')}</p>
          <h3>{t('labAI.section1.description', 'L\'Intelligence Artificielle n\'est plus une simple promesse, elle transforme activement les entreprises. Mais alors que les premières générations d\'IA ont démontré leur valeur sur des tâches spécifiques, la véritable révolution réside dans la collaboration intelligente.')}</h3>
        </div>
        <div className="intro-image">
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{position: 'absolute', bottom: 0, left: 0, width: '100%', borderTopLeftRadius: '100px', }}
          >
            <source src={ItmonkeysVideo} type="video/mp4" />
            {t('common.videoNotSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
          </video>
        </div>
      </div>

      <div className="intro-row-2">
        <div className="intro-text-2">
          <h2 className='blue-h2'>{t('labAI.section2.title', 'Un réseau d\'intelligences travaillant ensemble')}</h2>
          <p className="subtitle">{t('labAI.section2.subtitle', 'pour automatiser vos processus les plus complexes')}</p>
          <h3>
            {t('labAI.section2.description', 'Le futur appartient aux systèmes où des agents IA spécialisés interagissent, partagent des informations et coordonnent leurs actions pour résoudre des problèmes complexes et automatiser des processus métiers de bout en bout.')}
          </h3>
        </div>
        <div className="intro-image">
          <img src={DatacenterImage} alt={t('labAI.section2.imageAlt', 'Réseau IA')} />
        </div>
      </div>
    </div>
    </div>
    </div>
  );
};

export default IntroSectionLabAI;